module.exports = __webpack_public_path__ + "static/media/tarjetas-menu.35e3c4d8.png";